import { useCallback } from 'react';

const useModalUrlParam = () => {
    const setModalParam = useCallback((urlParam) => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set('modal', urlParam);
        window.history.pushState({}, '', currentUrl);
    }, []);

    const removeModalParam = useCallback(() => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.delete('modal');
        window.history.replaceState({}, '', currentUrl);
    }, []);

    return {
        setModalParam,
        removeModalParam,
    };
};

export default useModalUrlParam;